var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-container"},[_c('div',{staticClass:"step-container"},[_c('h2',{staticClass:"step"},[_vm._v(_vm._s(_vm.step))])]),_c('h2',{staticClass:"heading"},[_vm._v(_vm._s(_vm.heading))])])}
var staticRenderFns = []

export { render, staticRenderFns }